/* 正文 FAQ 折叠 —— 渐进增强
   老站(Enfold)用 av_toggle_section 把问答做成手风琴,导到 Shopify 之后正文
   只剩「标题 + 紧随其后的正文」平铺,47 个折叠一个不剩。正文是店铺级的、
   线上主题共用一份,所以不能改正文结构,只能在客户端把已经在页面上的
   「标题 + 内容」重新组装成可折叠面板。

   渐进增强:HTML 出来时内容是全部展开可读的,折叠是脚本装好面板之后才加的
   (hidden 属性由 JS 写),因此禁用 JS 时这几页跟现在一模一样、内容不丢。

   ── 判据(为什么不会把普通页面的标题也折叠掉)──────────────────
   只有同时满足下面全部条件的一组标题才会被折叠:
     1. 同一层级(h2..h6,h1 一律不碰 —— h1 是页面/分节主标题)的标题连续出现
        ≥ 3 个,中间不被更高层级的标题打断(更深层级的标题算作内容,不打断);
     2. 每个标题后面都有非空内容(纯「标题堆」不是问答);
     3. 每个标题本身非空;
     4. 这组内容里没有表单 / iframe / 脚本 / 表格 / Globo 表单容器
        —— 折叠掉表单会伤转化;
     5. 且满足下面任一 FAQ 特征:
        a) 一半以上的标题以「?」结尾(问答的天然特征),或
        b) 这组标题所属的上一级标题里带 FAQ / Frequently Asked Question 字样。
   实测(2026-08-18,店内 31 个页面正文全量跑过这套判据):命中且仅命中
   frequently-asked-questions(10)、barska-support(10)、dealer-support(6)
   —— 正好是老站三页的编辑型折叠数 10/10/6。
   反例:barska-support 上面 6 个服务磁贴是 h2、无「?」、无 FAQ 上级标题 → 不折叠;
   dealer-support 的 "Download Our Essential Resources"(单个)与 2 个
   "2022-2023 Product Catalog"(2 个、无「?」、上级标题是 PRODUCT CATALOGS)→ 不折叠;
   7 个品类页 / warranty-information / 岗位页的标题堆全部不折叠。
   老站 product-manuals 的 15 个分类折叠已被检索 + 分类筛选取代,这里正文没有对应
   标题结构,不受影响。 */
(function () {
	var FAQ_RE = /\bfaqs?\b|frequently\s+asked\s+question/i;
	var BLOCKERS = 'form, iframe, script, style, table, .globo-formbuilder, [data-wpshopify-component]';
	var MIN_RUN = 3;
	var uid = 0;

	function isHeading(node) {
		return node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
	}

	function level(node) {
		return parseInt(node.tagName.slice(1), 10);
	}

	function nodeText(node) {
		return (node.textContent || '').replace(/\s+/g, ' ').trim();
	}

	/* 把正文的直接子节点切成「标题 + 它后面的内容」若干段。
	   注意正文里的答案常常是裸文本节点(WP 导过来没有 <p> 包裹),
	   所以必须遍历 childNodes 而不是 children。 */
	function segment(body) {
		var parts = [];
		var cur = null;
		Array.prototype.slice.call(body.childNodes).forEach(function (node) {
			if (isHeading(node)) {
				cur = { level: level(node), heading: node, content: [] };
				parts.push(cur);
			} else if (cur) {
				cur.content.push(node);
			}
		});
		return parts;
	}

	function contentText(part) {
		return part.content
			.map(function (n) {
				return nodeText(n);
			})
			.join(' ')
			.trim();
	}

	function hasBlocker(part) {
		return part.content.some(function (n) {
			if (n.nodeType !== 1) return false;
			return n.matches(BLOCKERS) || !!n.querySelector(BLOCKERS);
		});
	}

	/* 层级 L 上的连续标题组:层级更浅的标题打断,更深的标题算内容不打断 */
	function runsAt(parts, L) {
		var runs = [];
		var cur = [];
		parts.forEach(function (p, i) {
			if (p.level === L) cur.push(i);
			else if (p.level < L) {
				if (cur.length) runs.push(cur);
				cur = [];
			}
		});
		if (cur.length) runs.push(cur);
		return runs;
	}

	function containerBefore(parts, idx, L) {
		for (var j = idx - 1; j >= 0; j--) {
			if (parts[j].level < L) return parts[j];
		}
		return null;
	}

	function qualifies(parts, run, L) {
		if (run.length < MIN_RUN) return false;
		var hs = run.map(function (i) {
			return parts[i];
		});
		if (
			hs.some(function (p) {
				return !nodeText(p.heading) || !contentText(p) || hasBlocker(p);
			})
		) {
			return false;
		}
		var questions = hs.filter(function (p) {
			return /\?$/.test(nodeText(p.heading));
		}).length;
		if (questions >= Math.ceil(hs.length / 2)) return true;
		var container = containerBefore(parts, run[0], L);
		return !!(container && FAQ_RE.test(nodeText(container.heading)));
	}

	function build(parts, run) {
		var list = document.createElement('div');
		list.className = 'bbf--list';
		list.setAttribute('data-body-faq-list', '');
		var first = parts[run[0]].heading;
		first.parentNode.insertBefore(list, first);

		run.forEach(function (idx) {
			var part = parts[idx];
			var heading = part.heading;
			uid += 1;
			var panelId = 'bbf-panel-' + uid;
			var buttonId = 'bbf-button-' + uid;

			var item = document.createElement('div');
			item.className = 'bbf--item';
			item.setAttribute('data-body-faq-item', '');

			var button = document.createElement('button');
			button.type = 'button';
			button.className = 'bbf--trigger';
			button.id = buttonId;
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-controls', panelId);
			var label = document.createElement('span');
			label.className = 'bbf--trigger-text';
			while (heading.firstChild) label.appendChild(heading.firstChild);
			var icon = document.createElement('span');
			icon.className = 'bbf--icon';
			icon.setAttribute('aria-hidden', 'true');
			button.appendChild(label);
			button.appendChild(icon);

			/* 保留原标题元素本身(含它的 id / class),只把内容搬进 button ——
			   页面上已有的锚点链接、自动目录生成的 id 才不会失效 */
			heading.classList.add('bbf--question');
			heading.appendChild(button);

			var panel = document.createElement('div');
			panel.className = 'bbf--answer';
			panel.id = panelId;
			panel.setAttribute('role', 'region');
			panel.setAttribute('aria-labelledby', buttonId);
			var inner = document.createElement('div');
			inner.className = 'bbf--answer-inner';
			part.content.forEach(function (n) {
				inner.appendChild(n);
			});
			panel.appendChild(inner);

			item.appendChild(heading);
			item.appendChild(panel);
			list.appendChild(item);

			/* 折叠态在这里才生效:没有 JS 的话上面这一切都不会发生,内容原样全展开 */
			panel.hidden = true;

			button.addEventListener('click', function () {
				setOpen(item, button.getAttribute('aria-expanded') !== 'true');
			});
		});
		return list;
	}

	function setOpen(item, open) {
		var button = item.querySelector('.bbf--trigger');
		var panel = item.querySelector('.bbf--answer');
		if (!button || !panel) return;
		button.setAttribute('aria-expanded', open ? 'true' : 'false');
		panel.hidden = !open;
		item.classList.toggle('is-open', open);
	}

	/* 深链:/pages/...#some-anchor 落在折叠面板里时先展开,否则用户看不到目标 */
	function openFromHash(root) {
		var id = (window.location.hash || '').slice(1);
		if (!id) return;
		var target = null;
		try {
			target = root.querySelector('#' + window.CSS.escape(id));
		} catch (e) {
			return;
		}
		if (!target) return;
		var item = target.closest('[data-body-faq-item]');
		if (item) {
			setOpen(item, true);
			target.scrollIntoView();
		}
	}

	function enhance(root) {
		var body = root.querySelector('[data-page-body]');
		if (!body || body.querySelector('[data-body-faq-item]')) return;

		var parts = segment(body);
		if (parts.length < MIN_RUN) return;

		/* 只在一个层级上折叠(取最深的那个合格层级)。一页里深浅两层都合格时,
		   浅层那组的「内容」本来就包住深层那组,两层都改会互相搬走节点。 */
		var chosen = [];
		for (var L = 6; L >= 2 && chosen.length === 0; L--) {
			chosen = runsAt(parts, L).filter(function (run) {
				return qualifies(parts, run, L);
			});
		}
		chosen.forEach(function (run) {
			build(parts, run);
		});
		if (chosen.length) {
			body.classList.add('bbf--enhanced');
			openFromHash(body);
			window.addEventListener('hashchange', function () {
				openFromHash(body);
			});
		}
	}

	function init() {
		Array.prototype.slice
			.call(document.querySelectorAll('[data-body-faq]'))
			.forEach(enhance);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
